import React from 'react';

const AnalyticIcon = ({ style }) => (
    <svg
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="currentColor"
        xmlns="http://www.w3.org/2000/svg"
        // eslint-disable-next-line tpe/no-inline-style -- TODO: legacy inline style (baseline)
        style={style}
    >
        <path d="M0.0010376 8.88889H7.11211V0H0.0010376V8.88889ZM0.0010376 16H7.11211V10.6667H0.0010376V16ZM8.88988 16H16.001V7.11111H8.88988V16ZM8.88988 0V5.33333H16.001V0H8.88988Z" />
    </svg>
);
export default AnalyticIcon;
